<template>
  <div class="city-div" v-bind:style="{ width: width }">
    <!-- 页面显示部分 -->
    <div class="city-input" v-bind:style="{ width: width }">
      <!-- 标签显示 -->
      <div class="input-label"></div>
      <!-- 输入框 -->
      <div
        ref="cityInput"
        class="search-input-main"
        @click.stop.prevent="showCityList"
      >
        <input
          type="text"
          readonly="true"
          class="search-input search-text fl"
          v-model="cityInputValue"
          :placeholder="placeholder"
          :class="{ 'is-disabled': disabled }"
          :title="cityInputValue"
        />
        <!-- <i class="drop" :class="{'dropUp': showCity, 'is-disabled': disabled}">▼</i> -->
        <i
          class="drop select e6-icon-arrow-b_line"
          :class="{ dropUp: showCity, 'is-disabled': disabled }"
        ></i>
      </div>
    </div>
    <!--选择层-->
    <transition name="zoom-in-top" :style="{ width: width }">
      <div
        class="city-select-list"
        v-show="showCity"
        :class="{
          'city-select-list-dropUp': direct,
          'city-select-list-dropDown': !direct
        }"
        ref="citySel"
      >
        <!-- 省市区tab切换 -->
        <div class="select-tab" v-if="city_format.length > 1">
          <div
            v-for="(tab, index) in city_format"
            :key="index"
            class="tab-item"
            :class="{ 'tab-active': curtab == tab }"
            :style="{ width: (1 / city_format.length) * 100 + '%' }"
            @click.stop.prevent="tabClick(tab)"
          >
            {{ tab }}
          </div>
        </div>
        <!-- 内容展示区 -->
        <div style="height: 100%; width: 100%; overflow: hidden;">
          <div class="select-text" @click.stop.prevent>
            <!-- <transition-group name="slide-fade-x" tag="div"> -->
            <transition-group
              enter-active-class="animated faster slideInRight"
              leave-active-class="animated faster slideOutLeft"
              :duration="{ enter: 500, leave: 1 }"
              tag="div"
            >
              <div v-show="curtab == '常用'" :key="'常用'">
                <ul>
                  <li
                    class="common"
                    v-for="(com, index) in common.data"
                    :key="'common' + index"
                    @click.stop.prevent="comClick(com)"
                  >
                    {{ com.name }}
                  </li>
                </ul>
              </div>
              <div v-show="curtab == '省'" :key="'省'">
                <ul>
                  <li
                    v-for="(pro, index) in cityData.province"
                    :key="'pro' + pro.bin + index"
                    @click.stop.prevent="proClick(pro)"
                  >
                    {{ pro.Name }}
                  </li>
                </ul>
              </div>
              <div v-show="curtab == '市'" :key="'市'">
                <ul>
                  <li
                    v-for="(city, index) in cityList"
                    :key="'city' + city.bin + index"
                    :title="city.Name"
                    @click.stop.prevent="cityClick(city)"
                  >
                    {{ city.Name }}
                  </li>
                </ul>
                <div class="no-data" v-if="!cityList.length">请选择省份</div>
              </div>
              <div v-show="curtab == '区县'" :key="'区县'">
                <ul>
                  <li
                    v-for="(district, index) in districtList"
                    :key="'district' + district.bin + index"
                    :title="district.Name"
                    @click.stop.prevent="districtClick(district)"
                  >
                    {{ district.Name }}
                  </li>
                </ul>
                <div class="no-data" v-if="!districtList.length">请选择市</div>
              </div>
            </transition-group>
          </div>
        </div>
        <div :class="['option', { empty: !isOptionShow }]">
          <a
            v-show="curtab == '常用' && common.link && common.link.url != ''"
            class="add"
            target="_blank"
            @click.stop.prevent="addCommon(common.link.url)"
            >{{ common.link ? common.link.label : "" }}</a
          >
          <a
            v-if="clearable"
            class="clear"
            @click.stop.prevent="clearCity"
            href="javascript:void(0)"
            >清除</a
          >
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
// import "animate.css";
import citys from "./city-data";
import echartsCityData from "./echarts-city-data";
export default {
  name: "echartsCity",
  data() {
    return {
      city_format: "",
      showCity: false,
      placeholderText: "", // 文本框默认显示
      windowHeight: "", // 浏览器窗口高度
      direct: true, // true向上展开   false 向下展开\
      cityInputValue: "",
      curtab: "省",
      cityData: [],
      cityList: [], //供选择的城市数据
      districtList: [], //区县选择数据
      selectedValue: 0, //最终选择的 Bin
      // tabData:['省','市','区县'],// 省市区tab
      pro: {
        bin: "",
        name: "",
        latlng: ""
      },
      city: {
        bin: "",
        name: "",
        latlng: ""
      },
      district: {
        bin: "",
        name: "",
        latlng: ""
      },
      heightStyle: 0,
      fixed: "" // 用来通过 fixedBin 来判断 是固定在  省市区哪个层级
    };
  },
  props: {
    format: {
      type: Array,
      default: function() {
        return ["省", "市", "区县"];
      }
    },
    // { data:[{id:0,label:'a'}],link:''}
    common: {
      type: Object,
      default: function() {
        return {};
      }
    },
    // 默认 城市bin
    bin: {
      type: Number,
      default: 0
    },
    // 固定城市的bin
    fixedBin: {
      type: Number,
      default: 0
    },
    // 默认 地址
    label: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    }, // 默认提示信息
    width: {
      type: String,
      default: "220px"
    }, // 默认宽度
    multiple: {
      type: Boolean,
      default: false
    }, // 多选
    disabled: {
      type: Boolean,
      default: false
    }, // 禁用功能
    maxSelectNum: {
      type: Number,
      default: 100000000
    },
    minSelectNum: {
      type: Number,
      default: 0
    },
    clearable: {
      type: Boolean,
      default: true
    }
    // 固定的  省 市 区  配合  bin 用
    // 比方，给了郑州市  的bin，希望只选择 郑州市 下的 区县数据
    // 比方，给了广东省 的bin，希望只选择 广东省 下的 城市数据 以及 城市下的 区县数据
    // fixed: {
    //   type: String,
    //   default: ""
    // }
  },
  watch: {
    label: {
      handler: function(val) {
        val && (this.cityInputValue = val);
      },
      immediate: true,
      deep: true
    },
    bin: {
      handler: function(val) {
        val && this.handleDefaultCity(val, false);
      },
      immediate: true,
      deep: true
    },
    fixedBin: {
      handler: function(val) {
        val && this.handleDefaultCity(val, true);
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    isProvince() {
      return this.city_format.some(item => {
        return item == "省";
      });
    },
    isCity() {
      return this.city_format.some(item => {
        return item == "市";
      });
    },
    isDistrict() {
      return this.city_format.some(item => {
        return item == "区" || item == "区县";
      });
    },
    isOptionShow() {
      return this.clearable || (this.common.link && this.common.link.url != "");
    }
  },
  created() {
    this.cityData = echartsCityData;
  },
  mounted() {
    this.initFormat();
    // 监听点击事件
    window.addEventListener("click", this.blur);
    // 监听浏览器高度变化
    // window.addEventListener("resize", this.handleResize);
  },
  methods: {
    initFormat() {
      let format = [];
      if (
        this.format.some(item => {
          return item == "常用";
        })
      ) {
        format.push("常用");
        this.curtab = "常用";
      }
      if (
        this.format.some(item => {
          return item == "省";
        })
      ) {
        format.push("省");
        this.curtab = "省";
      }
      if (
        this.format.some(item => {
          return item == "市";
        })
      ) {
        format.push("省");
        format.push("市");
        this.curtab = "省";
      }
      if (
        this.format.some(item => {
          return item == "区县";
        })
      ) {
        format.push("省");
        format.push("市");
        format.push("区县");
        this.curtab = "省";
      }
      let newFormat = Array.from(new Set(format));
      // 处理固定到某一个层级的逻辑
      if (this.isFixed()) {
        if (this.fixed === "省") {
          newFormat.splice(
            newFormat.findIndex(f => f === "省"),
            1
          );
          this.curtab = "市";
        } else if (this.fixed === "市") {
          newFormat.splice(
            newFormat.findIndex(f => f === "省"),
            1
          );
          newFormat.splice(
            newFormat.findIndex(f => f === "市"),
            1
          );
          this.curtab = "区县";
        }
      }
      this.city_format = newFormat;
    },
    isFixed() {
      return this.fixed !== "";
    },
    // 处理通过 bin 值 给默认的情况
    handleDefaultCity(bin, fixed = false) {
      if (this.cityData.length === 0) {
        setTimeout(() => {
          this.handleDefaultCity(bin, fixed);
        }, 100);
        return;
      }
      this.selectedValue = bin;
      let inputText = "";
      let datas = this.cityData.district.find(district => {
        return district.Bin == bin;
      });
      if (datas) {
        // 找到 区县 有匹配项，则选择的是区县，只用拼接 省市文本
        inputText = datas.ProvinceName + datas.CityName + datas.Name;
        this.pro.bin = datas.ProvinceBin;
        this.pro.name = datas.ProvinceName;
        this.city.bin = datas.CityBin;
        this.city.name = datas.CityName;
        this.district.bin = datas.Bin;
        this.district.name = datas.Name;
      } else {
        //  没有找到区县 则再找 市
        datas = this.cityData.city.find(city => {
          return city.Bin == bin;
        });
        if (datas) {
          // 找到 市 有匹配项
          inputText = datas.ProvinceName + datas.Name;
          this.pro.bin = datas.ProvinceBin;
          this.pro.name = datas.ProvinceName;
          this.city.bin = datas.Bin;
          this.city.name = datas.Name;
          // 在城市和省份范围，需要判断是否固定了省/市， 如果是，需要切换到对应数据
          if (fixed) {
            this.fixed = "市";
            this.districtList = this.cityData.district.filter(item => {
              return item.CityBin == datas.Bin;
            });
          }
        } else {
          datas = this.cityData.province.find(pro => {
            return pro.Bin == bin;
          });
          if (datas) {
            // 找到 省 有匹配项
            inputText = datas.Name;
            this.pro.bin = datas.Bin;
            this.pro.name = datas.Name;
            // 在城市和省份范围，需要判断是否固定了省/市， 如果是，需要切换到对应数据
            if (fixed) {
              this.fixed = "省";
              this.cityList = this.cityData.city.filter(item => {
                return item.ProvinceBin == datas.Bin;
              });
            }
          } else {
            inputText = "";
          }
        }
      }
      this.initFormat(); // 再初始化 format
      inputText !== "" && (this.cityInputValue = inputText);
    },
    // 浏览器高度变化处理函数
    handleResize() {
      this.$nextTick(() => {
        this.windowHeight = document.documentElement.clientHeight;
        // 然后获取div到浏览器窗口顶部的高度
        var divHeight = this.$refs.cityInput.getBoundingClientRect().top;
        // this.windowHeight浏览器窗口的高度
        // 下拉列表的高度 300px
        // 当windowHeight大于等于divHeight与scrollH的和的时候向下展开
        this.windowHeight = document.documentElement.clientHeight;
        this.heightStyle = this.$refs.citySel.clientHeight;
        if (this.windowHeight >= divHeight + this.heightStyle) {
          this.direct = false;
        } else {
          this.direct = true;
          this.$refs.citySel.style.marginTop = "0px";
        }
      });
    },
    blur() {
      if (this.showCity) {
        this.showCity = false;
        this.callBack();
      }
    },
    callBack() {
      this.$emit("selected", {
        province: this.pro,
        city: this.city,
        district: this.district,
        bin: this.district.bin
          ? this.district.bin
          : this.city.bin
          ? this.city.bin
          : this.pro.bin
          ? this.pro.bin
          : "",
        name: this.pro.name + this.city.name + this.district.name,
        latlng: this.district.bin
          ? this.district.latlng
          : this.city.bin
          ? this.city.latlng
          : this.pro.bin
          ? this.pro.latlng
          : ""
      });
    },
    showCityList() {
      // 组件是否禁用
      document.body.click();
      if (this.disabled) {
        return;
      }
      if (!this.showCity) {
        this.showCity = true;
      } else {
        this.blur();
      }
      this.handleResize();
    },
    // 清空
    clearCity() {
      this.cityInputValue = "";
      this.selectedValue = 0;
      this.curtab = this.curtab == "常用" ? this.curtab : "省";
      this.cityList = this.districtList = [];
      this.initProps("pro,city,dis");
      // this.callBack();
    },
    initProps(opr) {
      if (opr.indexOf("pro") > -1) {
        this.pro = {
          bin: "",
          name: "",
          latlng: ""
        };
      }
      if (opr.indexOf("city") > -1) {
        this.city = {
          bin: "",
          name: "",
          latlng: ""
        };
      }
      if (opr.indexOf("dis") > -1) {
        this.district = {
          bin: "",
          name: "",
          latlng: ""
        };
      }
    },
    addCommon(url) {
      window.open(url);
    },
    // tab切换点击
    tabClick(val) {
      this.curtab = val;
      this.handleResize();
    },
    // 常用地址 点击
    comClick(com) {
      this.cityInputValue = com.name;
      this.selectedValue = com.bin;
      this.showCity = false;
      this.$emit("selected", com);
    },
    // 点击省份
    proClick(pro) {
      this.initProps("pro,city,dis");
      this.pro.name = pro.Name;
      this.pro.bin = pro.Bin;
      this.cityInputValue = pro.Name;
      this.selectedValue = pro.Bin;
      let cPro = citys.cProvinceDatas.find(cpro => {
        return cpro.indexOf(pro.Name) > -1;
      });
      if (cPro) {
        this.pro.latlng = cPro.split("|")[1];
      }
      if (!this.isCity) {
        // 如果只选择省，不选择市
        this.blur();
      } else {
        this.cityList = this.cityData.city.filter(item => {
          return item.ProvinceBin == pro.Bin;
        });
        if (this.cityList.length > 0) {
          this.curtab = "市";
        } else {
          this.blur();
        }
      }
    },
    // 点击城市  切换区县数据
    cityClick(city) {
      this.initProps("city,dis");
      this.cityInputValue =
        this.pro.name == city.Name || city.Name == "不限"
          ? this.pro.name
          : this.pro.name + city.Name;
      if (city.Bin == 0) {
        this.city.name = "";
        this.city.bin = "";
        this.selectedValue = this.pro.bin;
        // 选择了不限
        this.blur();
      } else {
        this.city.name = city.Name;
        this.city.bin = city.Bin;
        this.selectedValue = city.Bin;
        if (citys.cCityDatas[this.pro.name]) {
          let cCity = citys.cCityDatas[this.pro.name].find(ccity => {
            return ccity.indexOf(city.Name) > -1;
          });
          if (cCity) {
            this.city.latlng = cCity.split("|")[1];
          }
        }
        this.districtList = this.cityData.district.filter(item => {
          return item.CityBin == city.Bin;
        });
        if (!this.isDistrict) {
          // 如果只选择到市，不选择区县
          this.blur();
        } else {
          if (this.districtList.length > 0) {
            this.curtab = "区县";
          } else {
            this.blur();
          }
        }
      }
    },
    // 区县点击
    districtClick(district) {
      this.initProps("dis");
      let label = "";
      if (this.pro.name == this.city.name) {
        label += this.pro.name;
      } else {
        label += this.pro.name + this.city.name;
      }

      if (district.Name != "不限") {
        label += district.Name;
      }

      this.cityInputValue = label;
      if (district.Bin != 0) {
        this.district.name = district.Name;
        this.district.bin = district.Bin;
        this.selectedValue = district.Bin;
      } else {
        this.district.name = "";
        this.district.bin = "";
        this.selectedValue = this.city.bin;
      }
      this.blur();
    }
  }
};
</script>
